// bad words filter is based on https://github.com/pychen0918/bad-words-chinese
import { words as banList } from './badWords.json'

// https://blog.miniasp.com/post/2019/01/02/Common-Regex-patterns-for-Unicode-characters
const whiteList = [
  '\\u4e00-\\u9fff', // 中日韓漢字
  '\\u2e80-\\u33ffh', // 注音
  '\\w', // 數字, 大小寫英文, 底線
  '\\s', // 空白, 換行符, tab
  '\\u0021-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E', // 半形標點符號
  '\\uFF01-\\uFF5E', // 全形英文, 標點符號
  '\\u3001-\\u303F', // 中日韓標點符號
  '\\u2000-\\u206F', // 通用 Unicode 標點符號
]

const notWhiteList = new RegExp(`[^${whiteList.join('|')}]`, 'g')

export default {
  isProfane(string) {
    // Chinese part
    const length = banList.length
    for (let i = length - 1; i >= 0; i--) {
      if (string.indexOf(banList[i]) > -1) {
        return true
      }
    }

    // English part
    const words = string.split(' ')
    for (let i = 0; i < words.length; i++) {
      const word = words[i].toLowerCase()
      if (banList.indexOf(word) > -1) {
        return true
      }
    }
    return false
  },
  isWhiteList(string) {
    return !notWhiteList.test(string)
  },
  replaceChar(string, replaceValue) {
    return string.replace(notWhiteList, replaceValue)
  },
}
